module.exports = __webpack_public_path__ + "img/logo-instagram.6644fd0a.png";